/* GQL fixes, 23 October 2026.
   Shopify's own cookie banner is written in US spelling and its wording cannot be edited in the admin.
   This swaps the visible spelling to British English. It changes text only, never the consent buttons or logic.
   If Shopify changes the banner markup, this simply does nothing. */
(function () {
  var MAP = [
    [/Personalization/g, 'Personalisation'], [/personalization/g, 'personalisation'],
    [/Personalize/g, 'Personalise'], [/personalize/g, 'personalise'],
    [/Optimization/g, 'Optimisation'], [/optimization/g, 'optimisation'],
    [/Optimize/g, 'Optimise'], [/optimize/g, 'optimise'],
    [/Customization/g, 'Customisation'], [/customization/g, 'customisation'],
    [/Customize/g, 'Customise'], [/customize/g, 'customise'],
    [/Analyze/g, 'Analyse'], [/analyze/g, 'analyse'],
    [/Organization/g, 'Organisation'], [/organization/g, 'organisation']
  ];
  var queued = false;

  function fixNode(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      var next = text;
      for (var i = 0; i < MAP.length; i++) { next = next.replace(MAP[i][0], MAP[i][1]); }
      if (next !== text) { node.nodeValue = next; }
    }
  }

  function run() {
    queued = false;
    try {
      var roots = document.querySelectorAll('[id^="shopify-pc__"]');
      for (var i = 0; i < roots.length; i++) { fixNode(roots[i]); }
    } catch (e) { /* never block the page */ }
  }

  function schedule() {
    if (queued) { return; }
    queued = true;
    window.requestAnimationFrame(run);
  }

  try {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    schedule();
  } catch (e) { /* ignore */ }
})();
